import { render, staticRenderFns } from "./ajdcbg.vue?vue&type=template&id=6c47d67b&scoped=true&"
import script from "./ajdcbg.vue?vue&type=script&lang=js&"
export * from "./ajdcbg.vue?vue&type=script&lang=js&"
import style0 from "./ajdcbg.vue?vue&type=style&index=0&id=6c47d67b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c47d67b",
  null
  
)

export default component.exports